<h2 class="mbottom-12">
  Select your use case
  <yat-tooltip-info-icon id="1eb76867-59ad-4090-93d2-e8911f873e29"
    iconClass="ml-1"
    tooltipContent="Both license types are linked to your Yatta account. Alternatively, you can register your academic organization to get access to a free multi-user license pool that is linked to the organization.">
  </yat-tooltip-info-icon>
</h2>
<form [formGroup]="teacherToggleForm" (yatSubmit)="submitForm($event)">
  <div class="form-row mbottom-12">
    <div class="col-12">
      <button
        type="button"
        class="use-case-button"
        [class.active]="teacherToggleForm.value.licenseScope === 'PERSONAL_USE'"
        (click)="selectLicenseScope('PERSONAL_USE')">
        <yat-icon id="66b82b12-9cf3-4657-9638-09bbe3e296ac" name="teacher"></yat-icon>
        <span>Single user license</span>
        <span class="description pt-1"> For your own personal use as a teacher, lecturer or researcher. Linked to your personal Yatta&nbsp;account. </span>
      </button>
    </div>
  </div>
  <div class="form-row mb-4">
    <div class="col-12">
      <button
        type="button"
        class="use-case-button"
        [class.active]="teacherToggleForm.value.licenseScope === 'CONCURRENT_USE'"
        (click)="selectLicenseScope('CONCURRENT_USE')">
        <yat-icon id="2c9fa05e-3d87-4fa4-8f2e-8a77969f2920" name="academic-multi" class="mb-1"></yat-icon>
        <span>Classroom or group license</span>
        <span class="description pt-1">
          Multi-user license is linked to your personal account. It allows you to issue floating sub-licenses to your class or research group. Sub-licenses do
          not require individual registration.
        </span>
      </button>
    </div>
  </div>

  <yat-buttons id="24748672-3d7c-4db3-8972-96921c69a95d" primaryButtonName="Continue" secondaryButtonName="Back" (secondaryButtonClickMethod)="goBack()" [useYatAutoSpinner]="false"> </yat-buttons>
</form>
